// Google Workspace usernames: letters, numbers, periods, hyphens and underscores.
// Separators can't lead, trail or repeat.
export const userNameRegex = /^[a-z0-9]+([._-][a-z0-9]+)*$/i;
// Google's limit for the part before @ in a primary address.
export const USER_NAME_MAX_LENGTH = 64;

export type UserNameIssue = 'tooLong' | 'invalid';

export function getUserNameIssue(userName: string): UserNameIssue | null {
  if (userName.length > USER_NAME_MAX_LENGTH) return 'tooLong';
  if (!userNameRegex.test(userName)) return 'invalid';
  return null;
}

export function normalizeNamePart(value: string) {
  return value
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .toLowerCase()
    .replace(/[^a-z0-9-]/g, '')
    .replace(/-+/g, '-')
    .replace(/^-|-$/g, '');
}

export function buildUserName(firstName: string, lastName: string) {
  const parts = [normalizeNamePart(firstName), normalizeNamePart(lastName)];
  return {
    userName: parts.filter(Boolean).join('.'),
    isComplete: parts.every(Boolean),
  };
}

// Strips characters the admin can't use (#, $, %, spaces, ...) as they type.
export function sanitizeUserNameInput(value: string) {
  return value.toLowerCase().replace(/[^a-z0-9._-]/g, '');
}
